import { render } from "./CoverButtonLink.vue?vue&type=template&id=debcf712"
import script from "./CoverButtonLink.vue?vue&type=script&lang=js"
export * from "./CoverButtonLink.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__